import { queryOptions, skipToken } from "@tanstack/vue-query";
import { getOrganizationTemplates, getPublicTemplates, getSharedAssetsFilesystems } from "ls/api/cloud/template";
import { STALE } from "ls/queries/staleTime";

export const queries = {
  sharedAssetFilesystems: (organizationId: string | undefined) =>
    queryOptions({
      queryKey: ["shared-assets", { organizationId }] as const,
      queryFn: organizationId
        ? ({ signal }) => getSharedAssetsFilesystems(organizationId, { signal })
        : skipToken,
    }),
  organizationTemplates: (organizationId: string) =>
    queryOptions({
      queryKey: ["templates", { organizationId }] as const,
      queryFn: ({ signal }) => getOrganizationTemplates(organizationId, { signal }),
    }),
  publicTemplates: () =>
    queryOptions({
      queryKey: ["public-templates"] as const,
      queryFn: ({ signal }) => getPublicTemplates({ signal }),
      staleTime: STALE.INFINITY,
    }),
};
